import React, { useState } from "react";
import { Link } from "react-router-dom";
import { createTaskFromBlocker, getApiErrorExtras, getApiErrorMessage } from "../../api";

export default function CreateTaskFromBlockerButton({
  sourceResponseId,
  sourceClientResponseId = null,
  boardId = null,
  label = "→ Задача",
}) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  const [taskBoardId, setTaskBoardId] = useState(null);
  const [taskId, setTaskId] = useState(null);

  const handleClick = async (e) => {
    e.stopPropagation();
    setLoading(true);
    setError(null);
    try {
      const task = await createTaskFromBlocker({
        source_response_id: sourceResponseId,
        source_client_response_id: sourceClientResponseId,
        board_id: boardId,
      });
      setTaskBoardId(task.board_id);
      setTaskId(task.id);
      setDone(true);
    } catch (err) {
      const extras = getApiErrorExtras(err);
      if (extras?.task_id) {
        setTaskBoardId(extras.board_id);
        setTaskId(extras.task_id);
        setDone(true);
        return;
      }
      setError(getApiErrorMessage(err, "Не удалось создать задачу"));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    const taskLink = taskBoardId
      ? `/tasks?board=${taskBoardId}${taskId ? `&task=${taskId}` : ""}`
      : null;

    return (
      <span className="blocker-task-created">
        {error ? error : "Создано"}
        {!error && taskLink && (
          <Link to={taskLink} className="blocker-task-link">
            Открыть
          </Link>
        )}
      </span>
    );
  }

  return (
    <button
      type="button"
      className="btn btn-sm blocker-task-btn"
      onClick={handleClick}
      disabled={loading}
    >
      {loading ? "..." : label}
    </button>
  );
}
